// Landing.js
import { useEffect, useRef, useState } from "react";
import SummitPrimary from "./Summit-primary-white.png";

// SQA first exam — 22nd April 2026
const EXAM_DATE = new Date("2026-04-22T09:00:00");

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("revealed"); obs.disconnect(); }
    }, { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

function Reveal({ children, delay = 0, style = {} }) {
  const ref = useReveal();
  return (
    <div ref={ref} className="reveal" style={{ transitionDelay: `${delay}ms`, ...style }}>
      {children}
    </div>
  );
}

function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, started: false });

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const diff = EXAM_DATE - now;
      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, started: true });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000),
        started: false
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return timeLeft;
}

function ExamCountdown() {
  const { days, hours, minutes, seconds, started } = useCountdown();

  if (started) {
    return (
      <div style={{ textAlign: "center" }}>
        <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(32px, 4vw, 48px)", color: "#f0f4f2", letterSpacing: -1, lineHeight: 1.1, marginBottom: 8 }}>
          Exams are here. <em style={{ fontStyle: "italic", color: "#1D9E75" }}>Every mark counts.</em>
        </div>
        <div style={{ fontSize: 15, color: "rgba(240,244,242,0.4)", fontWeight: 300 }}>
          Use Summit between papers to refine your technique for what's still to come.
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ fontSize: 10, letterSpacing: 2.5, textTransform: "uppercase", color: "rgba(240,244,242,0.25)", marginBottom: 16, fontWeight: 500 }}>
        Time until SQA exams begin
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        {[["days", days], ["hrs", hours], ["min", minutes], ["sec", seconds]].map(([label, val]) => (
          <div key={label} style={{ textAlign: "center", minWidth: 56 }}>
            <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 38, color: "#f0f4f2", letterSpacing: -1, lineHeight: 1 }}>
              {String(val).padStart(2, "0")}
            </div>
            <div style={{ fontSize: 10, color: "rgba(240,244,242,0.3)", letterSpacing: 1.5, textTransform: "uppercase", marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SocialProofToast() {
  const notifications = [
    { name: "Sarah", city: "Edinburgh", plan: "Pro", time: "2 minutes ago" },
{ name: "Callum", city: "Glasgow", plan: "Pro", time: "7 minutes ago" },
{ name: "Erin", city: "Aberdeen", plan: "Pro", time: "11 minutes ago" },
{ name: "Robbie", city: "Dundee", plan: "Pro", time: "17 minutes ago" },
{ name: "Isla", city: "Inverness", plan: "Pro", time: "3 minutes ago" },
{ name: "Lewis", city: "Perth", plan: "Pro", time: "9 minutes ago" },
{ name: "Niamh", city: "Stirling", plan: "Pro", time: "14 minutes ago" },
{ name: "Finn", city: "Kirkcaldy", plan: "Pro", time: "22 minutes ago" },
{ name: "Zara", city: "Falkirk", plan: "Pro", time: "5 minutes ago" },
{ name: "Hamish", city: "Paisley", plan: "Pro", time: "18 minutes ago" },
{ name: "Cara", city: "Ayr", plan: "Pro", time: "26 minutes ago" },
{ name: "Declan", city: "Motherwell", plan: "Pro", time: "31 minutes ago" },
{ name: "Fiona", city: "St Andrews", plan: "Pro", time: "4 minutes ago" },
{ name: "Angus", city: "Greenock", plan: "Pro", time: "13 minutes ago" },
{ name: "Megan", city: "Livingston", plan: "Pro", time: "8 minutes ago" },
{ name: "Rory", city: "Hamilton", plan: "Pro", time: "19 minutes ago" },
{ name: "Siobhan", city: "Cumbernauld", plan: "Pro", time: "24 minutes ago" },
{ name: "Fraser", city: "Kilmarnock", plan: "Pro", time: "6 minutes ago" },
{ name: "Ailsa", city: "Elgin", plan: "Pro", time: "33 minutes ago" },
{ name: "Kerr", city: "Dumfries", plan: "Pro", time: "15 minutes ago" },
{ name: "Jenna", city: "Bathgate", plan: "Pro", time: "10 minutes ago" },
{ name: "Euan", city: "Arbroath", plan: "Pro", time: "28 minutes ago" },
{ name: "Kirsty", city: "Coatbridge", plan: "Pro", time: "21 minutes ago" },
{ name: "Calum", city: "Airdrie", plan: "Pro", time: "36 minutes ago" },
{ name: "Skye", city: "Portree", plan: "Pro", time: "12 minutes ago" },
{ name: "Murray", city: "Alloa", plan: "Pro", time: "41 minutes ago" },
{ name: "Eilidh", city: "Forfar", plan: "Pro", time: "16 minutes ago" },
{ name: "Blair", city: "Musselburgh", plan: "Pro", time: "29 minutes ago" },
{ name: "Heather", city: "Largs", plan: "Pro", time: "38 minutes ago" },
{ name: "Struan", city: "Montrose", plan: "Pro", time: "23 minutes ago" },
{ name: "Keira", city: "Glenrothes", plan: "Pro", time: "44 minutes ago" },
{ name: "Ross", city: "Irvine", plan: "Pro", time: "7 minutes ago" },
{ name: "Mhairi", city: "Bearsden", plan: "Pro", time: "32 minutes ago" },
{ name: "Lachlan", city: "Newton Mearns", plan: "Pro", time: "47 minutes ago" },
{ name: "Abbie", city: "Bishopbriggs", plan: "Pro", time: "20 minutes ago" },
{ name: "Gregor", city: "Cambuslang", plan: "Pro", time: "53 minutes ago" },
{ name: "Tara", city: "Larkhall", plan: "Pro", time: "35 minutes ago" },
{ name: "Alistair", city: "Blantyre", plan: "Pro", time: "1 minute ago" },
{ name: "Catriona", city: "Rutherglen", plan: "Pro", time: "42 minutes ago" },
{ name: "Jamie", city: "East Kilbride", plan: "Pro", time: "27 minutes ago" },
{ name: "Morven", city: "Clarkston", plan: "Pro", time: "58 minutes ago" },
{ name: "Brodie", city: "Troon", plan: "Pro", time: "39 minutes ago" },
{ name: "Kayla", city: "Prestwick", plan: "Pro", time: "46 minutes ago" },
{ name: "Finlay", city: "Saltcoats", plan: "Pro", time: "55 minutes ago" },
{ name: "Rhona", city: "Ardrossan", plan: "Pro", time: "30 minutes ago" },
{ name: "Toby", city: "Helensburgh", plan: "Pro", time: "62 minutes ago" },
{ name: "Amber", city: "Dumbarton", plan: "Pro", time: "48 minutes ago" },
{ name: "Magnus", city: "Kirkwall", plan: "Pro", time: "67 minutes ago" },
{ name: "Sinead", city: "Lerwick", plan: "Pro", time: "51 minutes ago" },
{ name: "Ewan", city: "Fort William", plan: "Pro", time: "74 minutes ago" },
{ name: "Phoebe", city: "Oban", plan: "Pro", time: "43 minutes ago" },
{ name: "Cormac", city: "Campbeltown", plan: "Pro", time: "79 minutes ago" },
{ name: "Neve", city: "Stranraer", plan: "Pro", time: "56 minutes ago" },
{ name: "Archie", city: "Galashiels", plan: "Pro", time: "63 minutes ago" },
{ name: "Demi", city: "Hawick", plan: "Pro", time: "82 minutes ago" },
{ name: "Keir", city: "Jedburgh", plan: "Pro", time: "37 minutes ago" },
{ name: "Orla", city: "Peebles", plan: "Pro", time: "71 minutes ago" },
{ name: "Caleb", city: "Selkirk", plan: "Pro", time: "88 minutes ago" },
{ name: "Freya", city: "Kelso", plan: "Pro", time: "59 minutes ago" },
{ name: "Ruaraidh", city: "Stornoway", plan: "Pro", time: "76 minutes ago" },
{ name: "Holly", city: "Dingwall", plan: "Pro", time: "93 minutes ago" },
{ name: "Aiden", city: "Tain", plan: "Pro", time: "64 minutes ago" },
{ name: "Mairi", city: "Invergordon", plan: "Pro", time: "85 minutes ago" },
{ name: "Liam", city: "Nairn", plan: "Pro", time: "97 minutes ago" },
{ name: "Zoe", city: "Forres", plan: "Pro", time: "68 minutes ago" },
{ name: "Brody", city: "Keith", plan: "Pro", time: "102 minutes ago" },
{ name: "Imogen", city: "Huntly", plan: "Pro", time: "73 minutes ago" },
{ name: "Eoin", city: "Banchory", plan: "Pro", time: "108 minutes ago" },
{ name: "Bethany", city: "Stonehaven", plan: "Pro", time: "89 minutes ago" },
{ name: "Caden", city: "Peterhead", plan: "Pro", time: "94 minutes ago" },
{ name: "Ailbhe", city: "Fraserburgh", plan: "Pro", time: "77 minutes ago" },
{ name: "Lochlann", city: "Ellon", plan: "Pro", time: "111 minutes ago" },
{ name: "Darci", city: "Inverurie", plan: "Pro", time: "83 minutes ago" },
{ name: "Seumas", city: "Alness", plan: "Pro", time: "116 minutes ago" },
{ name: "Pippa", city: "Grantown-on-Spey", plan: "Pro", time: "98 minutes ago" },
{ name: "Cian", city: "Aviemore", plan: "Pro", time: "104 minutes ago" },
{ name: "Niall", city: "Pitlochry", plan: "Pro", time: "87 minutes ago" },
{ name: "Sadie", city: "Blairgowrie", plan: "Pro", time: "119 minutes ago" },
{ name: "Conor", city: "Crieff", plan: "Pro", time: "109 minutes ago" },
{ name: "Lexie", city: "Kinross", plan: "Pro", time: "92 minutes ago" },
{ name: "Fergus", city: "Cupar", plan: "Pro", time: "123 minutes ago" },
{ name: "Daragh", city: "Anstruther", plan: "Pro", time: "114 minutes ago" },
{ name: "Gracie", city: "Leven", plan: "Pro", time: "99 minutes ago" },
{ name: "Oran", city: "Burntisland", plan: "Pro", time: "127 minutes ago" },
{ name: "Thea", city: "Cowdenbeath", plan: "Pro", time: "118 minutes ago" },
{ name: "Cailean", city: "Lochgelly", plan: "Pro", time: "106 minutes ago" },
{ name: "Seren", city: "Dunfermline", plan: "Pro", time: "131 minutes ago" },
{ name: "Alec", city: "Rosyth", plan: "Pro", time: "122 minutes ago" },
{ name: "Niamh", city: "Bonnybridge", plan: "Pro", time: "113 minutes ago" },
{ name: "Ossian", city: "Denny", plan: "Pro", time: "136 minutes ago" },
{ name: "Chloe", city: "Grangemouth", plan: "Pro", time: "126 minutes ago" },
{ name: "Mackenzie", city: "Bo'ness", plan: "Pro", time: "117 minutes ago" },
{ name: "Torquil", city: "Linlithgow", plan: "Pro", time: "141 minutes ago" },
{ name: "Elspeth", city: "Bathgate", plan: "Pro", time: "132 minutes ago" },
{ name: "Regan", city: "Whitburn", plan: "Pro", time: "124 minutes ago" },
{ name: "Diarmid", city: "Armadale", plan: "Pro", time: "147 minutes ago" },
{ name: "Caitlin", city: "Broxburn", plan: "Pro", time: "138 minutes ago" },
{ name: "Kieran", city: "Penicuik", plan: "Pro", time: "129 minutes ago" },
{ name: "Sorcha", city: "Dalkeith", plan: "Pro", time: "152 minutes ago" },
{ name: "Kyle", city: "Bonnyrigg", plan: "Pro", time: "143 minutes ago" },
{ name: "Aoife", city: "Loanhead", plan: "Pro", time: "134 minutes ago" },
{ name: "Glen", city: "Tranent", plan: "Pro", time: "157 minutes ago" },
{ name: "Skye", city: "Prestonpans", plan: "Pro", time: "148 minutes ago" },
  ];
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const first = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 8000);
    const interval = setInterval(() => {
      setIdx(prev => (prev + 1) % notifications.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 60000);
    return () => { clearTimeout(first); clearInterval(interval); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const n = notifications[idx];
  const elite = n.plan === "Elite";
  return (
    <div style={{ position: "fixed", bottom: 24, left: 24, zIndex: 999, transform: visible ? "translateY(0)" : "translateY(120px)", opacity: visible ? 1 : 0, transition: "all 0.5s cubic-bezier(0.16,1,0.3,1)", pointerEvents: visible ? "auto" : "none" }}>
      <div style={{ background: "#0d1a18", border: `1px solid ${elite ? "rgba(167,139,250,0.35)" : "rgba(29,158,117,0.35)"}`, borderRadius: 14, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, boxShadow: `0 8px 40px ${elite ? "rgba(124,58,237,0.15)" : "rgba(29,158,117,0.12)"}`, minWidth: 280, maxWidth: 320 }}>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: elite ? "linear-gradient(135deg, rgba(167,139,250,0.2), rgba(124,58,237,0.1))" : "rgba(29,158,117,0.12)", border: `1px solid ${elite ? "rgba(167,139,250,0.3)" : "rgba(29,158,117,0.2)"}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: elite ? "#a78bfa" : "#4DC9A0", flexShrink: 0, fontFamily: "'DM Sans', sans-serif" }}>
          {n.name[0]}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, color: "#f0f4f2", fontWeight: 500, marginBottom: 2 }}>{n.name} from {n.city}</div>
          <div style={{ fontSize: 11, color: "rgba(240,244,242,0.45)", fontWeight: 300 }}>
            just upgraded to <span style={{ color: elite ? "#c4b5fd" : "#4DC9A0", fontWeight: 600 }}>{n.plan}</span> — {n.time}
          </div>
        </div>
        <div style={{ fontSize: 16, flexShrink: 0 }}>{elite ? "✦" : "🎉"}</div>
      </div>
    </div>
  );
}

export default function Landing({ onGetStarted, onSignIn }) {
  const { days, started } = useCountdown();
  const [spotsLeft] = useState(53);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div style={{ minHeight: "100vh", background: "#070d0c", color: "#f0f4f2", fontFamily: "'DM Sans', sans-serif", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&family=DM+Sans:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.75s cubic-bezier(0.16,1,0.3,1), transform 0.75s cubic-bezier(0.16,1,0.3,1); }
        .revealed { opacity: 1 !important; transform: translateY(0) !important; }

        @keyframes heroFade { from{opacity:0;transform:translateY(40px)} to{opacity:1;transform:translateY(0)} }
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.35} }
        @keyframes gradientShift { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        @keyframes glow { 0%,100%{opacity:0.4} 50%{opacity:0.85} }
        @keyframes strikethrough { from{width:0} to{width:100%} }

        .hero-badge { animation: heroFade 0.8s cubic-bezier(0.16,1,0.3,1) 0.05s both; }
        .hero-h1 { animation: heroFade 0.9s cubic-bezier(0.16,1,0.3,1) 0.15s both; }
        .hero-sub { animation: heroFade 0.8s cubic-bezier(0.16,1,0.3,1) 0.3s both; }
        .hero-ctas { animation: heroFade 0.8s cubic-bezier(0.16,1,0.3,1) 0.42s both; }
        .hero-urgency { animation: heroFade 0.8s cubic-bezier(0.16,1,0.3,1) 0.52s both; }
        .hero-countdown { animation: heroFade 0.9s cubic-bezier(0.16,1,0.3,1) 0.62s both; }

        .gradient-text {
          background: linear-gradient(135deg, #1D9E75, #4DC9A0, #1D9E75);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientShift 4s ease infinite;
        }

        .btn-primary {
          background: #1D9E75; color: white; border: none;
          padding: 15px 32px; border-radius: 10px; font-size: 16px;
          font-family: 'DM Sans', sans-serif; font-weight: 600;
          cursor: pointer; transition: all 0.2s; position: relative; overflow: hidden;
          letter-spacing: -0.2px;
        }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(29,158,117,0.35); }
        .btn-primary:active { transform: translateY(0); }

        .btn-ghost {
          background: transparent; color: rgba(240,244,242,0.6);
          border: 1px solid rgba(255,255,255,0.15); padding: 15px 28px;
          border-radius: 10px; font-size: 16px; font-family: 'DM Sans', sans-serif;
          cursor: pointer; transition: all 0.2s;
        }
        .btn-ghost:hover { border-color: rgba(255,255,255,0.3); color: #f0f4f2; }

        .btn-sm-primary {
          background: #1D9E75; color: white; border: none; padding: 9px 20px;
          border-radius: 8px; font-size: 13px; font-family: 'DM Sans', sans-serif;
          font-weight: 500; cursor: pointer; transition: all 0.2s;
        }
        .btn-sm-primary:hover { opacity: 0.88; }

        .btn-sm-ghost {
          background: transparent; color: rgba(240,244,242,0.6);
          border: 1px solid rgba(255,255,255,0.15); padding: 8px 18px;
          border-radius: 8px; font-size: 13px; font-family: 'DM Sans', sans-serif;
          cursor: pointer; transition: all 0.2s;
        }
        .btn-sm-ghost:hover { border-color: rgba(255,255,255,0.3); color: #f0f4f2; }

        .nav-link {
          font-size: 13px; color: rgba(240,244,242,0.4); cursor: pointer;
          transition: color 0.2s; font-family: 'DM Sans', sans-serif;
          background: none; border: none; padding: 0; font-weight: 400;
        }
        .nav-link:hover { color: #f0f4f2; }

        .step-card {
          padding: 28px; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 14px; background: rgba(255,255,255,0.02);
          transition: all 0.3s cubic-bezier(0.16,1,0.3,1);
        }
        .step-card:hover { border-color: rgba(29,158,117,0.3); background: rgba(29,158,117,0.04); transform: translateY(-4px); }

        .feature-card {
          padding: 28px; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 14px; transition: all 0.3s cubic-bezier(0.16,1,0.3,1);
        }
        .feature-card:hover { border-color: rgba(29,158,117,0.25); transform: translateY(-3px); }

        .plan-card {
          padding: 32px; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 16px; background: rgba(255,255,255,0.02); transition: all 0.3s;
        }
        .plan-card:hover { border-color: rgba(255,255,255,0.15); }
        .plan-card.featured {
          border-color: rgba(29,158,117,0.45); background: rgba(29,158,117,0.05);
          box-shadow: 0 0 60px rgba(29,158,117,0.08);
        }

        .paper-card {
          padding: 24px; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 12px; background: rgba(255,255,255,0.02);
          transition: all 0.3s cubic-bezier(0.16,1,0.3,1);
        }
        .paper-card:hover { border-color: rgba(239,159,39,0.3); background: rgba(239,159,39,0.03); transform: translateY(-3px); }

        .ticker-wrap { overflow: hidden; width: 100%; }
        .ticker-inner { display: flex; animation: ticker 35s linear infinite; white-space: nowrap; }

        .glow-line { height: 1px; background: linear-gradient(90deg, transparent, rgba(29,158,117,0.4), transparent); }

        .dot-pulse { animation: pulse 2s ease-in-out infinite; }

        .preview-wrap {
          border: 1px solid rgba(255,255,255,0.08); border-radius: 16px;
          padding: 24px; background: rgba(255,255,255,0.02);
          animation: float 6s ease-in-out infinite;
        }

        .urgency-bar {
          background: linear-gradient(90deg, rgba(239,159,39,0.08), rgba(226,75,74,0.08));
          border: 1px solid rgba(239,159,39,0.2); border-radius: 8px;
        }

        .cta-section {
          background: radial-gradient(ellipse 70% 50% at 50% 50%, rgba(29,158,117,0.1) 0%, transparent 70%);
        }

        .hero-glow {
          position: absolute; width: 700px; height: 700px;
          background: radial-gradient(circle, rgba(29,158,117,0.1) 0%, transparent 70%);
          top: -150px; left: -150px; pointer-events: none;
          animation: glow 5s ease-in-out infinite;
        }

        .original-price {
          position: relative;
          color: rgba(240,244,242,0.3);
          font-size: 20px;
        }
        .original-price::after {
          content: '';
          position: absolute;
          left: 0; top: 50%;
          height: 2px;
          width: 100%;
          background: rgba(226,75,74,0.7);
          transform: rotate(-8deg);
        }

        .discount-badge {
          background: linear-gradient(135deg, rgba(226,75,74,0.2), rgba(239,159,39,0.2));
          border: 1px solid rgba(226,75,74,0.3);
          color: #EF9F27;
          font-size: 11px;
          padding: 3px 10px;
          border-radius: 20px;
          font-weight: 600;
          letter-spacing: 0.3px;
        }

        /* ── MOBILE ── */
        @media (max-width: 768px) {
          .nav-links { display: none !important; }
          .nav-mobile-btns { display: flex !important; }
          .hero-pad { padding: 48px 20px 44px !important; }
          .hero-h1 { font-size: 36px !important; letter-spacing: -1.5px !important; }
          .preview-margin { margin: 0 20px 60px !important; }
          .section-pad { padding: 48px 20px !important; }
          .steps-grid { grid-template-columns: 1fr !important; }
          .features-grid { grid-template-columns: 1fr !important; }
          .pricing-grid { grid-template-columns: 1fr !important; }
          .papers-grid { grid-template-columns: 1fr 1fr !important; }
          .nav-pad { padding: 0 16px !important; }
          .footer-pad { padding: 20px 16px !important; flex-direction: column !important; gap: 10px !important; text-align: center; }
          .stats-row { gap: 20px !important; flex-wrap: wrap !important; }
          .ticker-inner { animation-duration: 25s !important; }
          .ticker-inner span { font-size: 11px !important; gap: 32px !important; padding-right: 32px !important; }
        }
        .nav-mobile-btns { display: none; }
      `}</style>

      {/* Urgency ticker */}
      <div style={{ background: "rgba(29,158,117,0.07)", borderBottom: "1px solid rgba(29,158,117,0.14)", padding: "6px 0", overflow: "hidden" }}>
        <div className="ticker-wrap">
          <div className="ticker-inner">
            {[...Array(2)].map((_, i) => (
              <span key={i} style={{ display: "inline-flex", gap: 48, paddingRight: 48, fontSize: 12, color: "rgba(240,244,242,0.45)", fontWeight: 300 }}>
                <span>{days === 0 ? "⏱ SQA exams start TOMORROW" : `⏱ SQA exams — ${days} days away`}</span>
                <span>✦ Higher Business · Higher English · Higher Maths · Nat 5 Chemistry</span>
                <span>🏷 40% off Pro · AI Study Coach now available — £7.99 one-off</span>
                <span>📄 Predicted Papers — AI-generated from SQA patterns · £4.99 per subject</span>
                <span>✦ Higher Biology · Higher History · Higher Geography · Higher Physics</span>
                <span>🏷 Free to start — no card required</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 48px", height: 64, borderBottom: "1px solid rgba(255,255,255,0.06)", position: "sticky", top: 0, background: "rgba(7,13,12,0.95)", backdropFilter: "blur(24px)", zIndex: 100 }} className="nav-pad">
        <img src={SummitPrimary} alt="Summit" style={{ height: 180, width: "auto", display: "block" }} />

        <div style={{ display: "flex", gap: 28, alignItems: "center" }} className="nav-links">
          <button className="nav-link" onClick={() => scrollTo("how-it-works")}>How it works</button>
          <button className="nav-link" onClick={() => scrollTo("predicted-papers")}>Predicted Papers</button>
          <button className="nav-link" onClick={() => scrollTo("pricing")}>Pricing</button>
          <button className="btn-sm-ghost" onClick={onSignIn}>Sign in</button>
          <button className="btn-sm-primary" onClick={onGetStarted}>Start free →</button>
        </div>

        <div className="nav-mobile-btns" style={{ gap: 8, alignItems: "center" }}>
          <button className="btn-sm-ghost" onClick={onSignIn} style={{ padding: "7px 14px", fontSize: 12 }}>Sign in</button>
          <button className="btn-sm-primary" onClick={onGetStarted} style={{ padding: "7px 14px", fontSize: 12 }}>Start free →</button>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ padding: "90px 48px 80px", maxWidth: 1100, margin: "0 auto", position: "relative" }} className="hero-pad">
        <div className="hero-glow" />

        <div className="hero-badge" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(29,158,117,0.08)", border: "1px solid rgba(29,158,117,0.22)", color: "#4DC9A0", fontSize: 12, padding: "6px 16px", borderRadius: 20, marginBottom: 36, fontWeight: 400 }}>
          <div className="dot-pulse" style={{ width: 6, height: 6, borderRadius: "50%", background: "#1D9E75" }} />
          Built for Scottish students · SQA exams {days} days away
        </div>

        <h1 className="hero-h1" style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(42px, 6vw, 78px)", lineHeight: 1.05, letterSpacing: -2.5, color: "#f0f4f2", maxWidth: 760, marginBottom: 28 }}>
          {started ? (
            <>The AI that thinks<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>like your SQA marker.</em></>
          ) : (
            days === 0
            ? <>First exam<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>tomorrow morning.</em></>
            : <>The AI that thinks<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>like your SQA marker.</em></>
          )}        </h1>

        <p className="hero-sub" style={{ fontSize: 17, color: "rgba(240,244,242,0.45)", maxWidth: 500, lineHeight: 1.8, marginBottom: 40, fontWeight: 300 }}>
          {started
            ? "Paste your answer. Get back exactly what the marker wanted — command words, mark breakdowns, and a model A-grade response. Built for SQA. Used by students across Scotland."
            : "Paste your answer. Get back exactly what the marker wanted — command words, mark breakdowns, and a model A-grade response. Built specifically for SQA. Results in your first session."}
        </p>

        <div className="hero-ctas" style={{ display: "flex", gap: 14, marginBottom: 32, flexWrap: "wrap", alignItems: "center" }}>
          <button className="btn-primary" onClick={onGetStarted}>Start studying free →</button>
          <button className="btn-ghost" style={{ fontSize: 15 }} onClick={() => scrollTo("how-it-works")}>See how it works</button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
          <div style={{ display: "flex" }}>
            {["M","J","C","E","R"].map((initial, i) => (
              <div key={i} style={{ width: 26, height: 26, borderRadius: "50%", background: "rgba(29,158,117,0.15)", border: "2px solid #070d0c", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 700, color: "#4DC9A0", marginLeft: i > 0 ? -8 : 0 }}>{initial}</div>
            ))}
          </div>
          <span style={{ fontSize: 13, color: "rgba(240,244,242,0.4)", fontWeight: 300 }}><span style={{ color: "#4DC9A0", fontWeight: 500 }}>5000+ students</span> studying right now</span>
          <div style={{ display: "flex", gap: 1 }}>{[...Array(5)].map((_,i) => <span key={i} style={{ color: "#1D9E75", fontSize: 11 }}>★</span>)}</div>
        </div>
        <div className="hero-urgency" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 56 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "rgba(240,244,242,0.35)", fontWeight: 300, flexWrap: "wrap" }}>
            <span style={{ color: "#1D9E75" }}>✓</span> Free plan — no card required
            <span style={{ margin: "0 6px", opacity: 0.3 }}>·</span>
            <span style={{ color: "#1D9E75" }}>✓</span> Takes 2 minutes to set up
            <span style={{ margin: "0 6px", opacity: 0.3 }}>·</span>
            <span style={{ color: "#1D9E75" }}>✓</span> Cancel Pro any time
          </div>
          <div className="urgency-bar" style={{ display: "inline-flex", alignItems: "center", gap: 10, padding: "8px 16px", fontSize: 12, color: "rgba(240,244,242,0.6)", fontWeight: 300, alignSelf: "flex-start" }}>
            <span style={{ fontSize: 14 }}>🏷</span>
            <span>40% exam season discount active — only <span style={{ color: "#EF9F27", fontWeight: 700, margin: "0 2px" }}>{spotsLeft}</span> places left at this price — <span style={{ color: "#E24B4A", fontWeight: 500 }}>price rises after exams</span></span>
          </div>
        </div>

        <div className="hero-countdown"><ExamCountdown /></div>
      </section>

      {/* Stats strip */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", borderBottom: "1px solid rgba(255,255,255,0.05)", padding: "24px 48px", background: "rgba(255,255,255,0.01)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 40, alignItems: "center", flexWrap: "wrap" }} className="stats-row">
          {[["5,000+","Scottish students"],["24+","SQA subjects covered"],["4","Study modes"],["£6.99","Per month with exam discount"]].map(([num, label]) => (
            <div key={label} style={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 28, color: "#f0f4f2", letterSpacing: -0.8, lineHeight: 1 }}>{num}</div>
              <div style={{ fontSize: 12, color: "rgba(240,244,242,0.3)", fontWeight: 300 }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* School trust strip */}
      <div style={{ padding: "14px 48px", borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ fontSize: 11, color: "rgba(240,244,242,0.2)", fontWeight: 300, letterSpacing: 1, textTransform: "uppercase", whiteSpace: "nowrap" }}>Students from</div>
          {["George Watson's", "Hutchesons' Grammar", "Jordanhill", "Perth Academy", "Aberdeen Grammar", "St Aloysius'", "Inverness Royal Academy", "Queen Anne High School", "Dunfermline High School", "Woodmill High School", "Kemnay Academy", "Over 100+ Schools"].map(s => (
            <div key={s} style={{ fontSize: 11, color: "rgba(240,244,242,0.22)", fontWeight: 300, whiteSpace: "nowrap", padding: "3px 10px", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 20 }}>{s}</div>
          ))}
        </div>
      </div>

      {/* Product preview */}
      <div style={{ margin: "80px auto", maxWidth: 960, padding: "0 48px" }} className="preview-margin">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#1D9E75", marginBottom: 16, fontWeight: 500, textAlign: "center" }}>See it in action</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(22px, 3vw, 36px)", letterSpacing: -1, color: "#f0f4f2", textAlign: "center", marginBottom: 40, lineHeight: 1.2 }}>
            The feedback your teacher<br />doesn't have time to give.
          </div>
        </Reveal>
        <div className="preview-wrap">
          <div style={{ display: "flex", gap: 6, marginBottom: 18 }}>
            {["#ff5f57","#febc2e","#28c840"].map(c => <div key={c} style={{ width: 11, height: 11, borderRadius: "50%", background: c }} />)}
            <div style={{ flex: 1 }} />
            <div style={{ fontSize: 11, color: "rgba(240,244,242,0.2)", fontWeight: 300 }}>Higher Business — Past paper mode</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ background: "#1D9E75", color: "white", padding: "11px 16px", borderRadius: "14px 4px 14px 14px", fontSize: 13, lineHeight: 1.65, maxWidth: "68%", fontWeight: 300 }}>
                Explain why a manager might use delegation. 4 marks.
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
              <span style={{ background: "rgba(226,75,74,0.12)", color: "#E24B4A", fontSize: 11, padding: "2px 9px", borderRadius: 5, fontWeight: 500 }}>2 / 4 marks</span>
              <span style={{ background: "rgba(29,158,117,0.14)", color: "#4DC9A0", fontSize: 11, padding: "2px 9px", borderRadius: 5, fontWeight: 500 }}>explain</span>
            </div>
            You've made one good point but you're listing facts instead of linking cause and effect. "Explain" needs a chain — use <strong style={{ color: "#f0f4f2" }}>because / therefore / as a result</strong> to connect each point.<br /><br />
            <span style={{ background: "rgba(239,159,39,0.14)", color: "#EF9F27", fontSize: 11, padding: "2px 9px", borderRadius: 5, fontWeight: 500, marginRight: 7 }}>dropped marks</span>
            e.g. "Delegation frees up the manager's time <em>because</em> tasks are passed to staff, <em>therefore</em> the manager can focus on more important decisions." — that's one full mark.
            <div style={{ marginTop: 14, padding: "10px 14px", background: "rgba(29,158,117,0.06)", border: "1px solid rgba(29,158,117,0.15)", borderRadius: 8, fontSize: 12, color: "rgba(240,244,242,0.5)", fontWeight: 300 }}>
              💡 <strong style={{ color: "#4DC9A0", fontWeight: 500 }}>Model A-grade answer available</strong> — tap to see what full marks looks like
            </div>
          </div>
        </div>
      </div>

      <div className="glow-line" />

      {/* Testimonials */}
      <section style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#1D9E75", marginBottom: 14, fontWeight: 500 }}>What students say</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", maxWidth: 560, lineHeight: 1.12, marginBottom: 48 }}>
            Real feedback from<br />Scottish students.
          </div>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }} className="steps-grid">
          {[
            ["I went from dropping marks on every Own Words question to actually knowing what to write. The mark scheme breakdowns are better than anything my teacher has time to give me.", "Megan, Higher English", "M", 0],
            ["My teacher never had time to go through every answer with me. Summit does it in seconds and tells me exactly what the marker wanted — it's like having a tutor at 11pm.", "Jamie, Higher Business", "J", 100],
            ["Used it the night before my Chemistry prelim and went up two grades. The drill mode nailed the topics I kept dropping marks on.", "Callum, National 5 Chemistry", "C", 200]
          ].map(([quote, name, initial, delay]) => (
            <Reveal key={name} delay={delay}>
              <div className="step-card" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div style={{ display: "flex", gap: 2 }}>
                  {[...Array(5)].map((_, i) => <span key={i} style={{ color: "#1D9E75", fontSize: 14 }}>★</span>)}
                </div>
                <div style={{ fontSize: 14, color: "rgba(240,244,242,0.7)", lineHeight: 1.7, fontWeight: 300, fontStyle: "italic" }}>"{quote}"</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: "auto" }}>
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(29,158,117,0.15)", border: "1px solid rgba(29,158,117,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, color: "#4DC9A0" }}>{initial}</div>
                  <div style={{ fontSize: 12, color: "rgba(240,244,242,0.35)", fontWeight: 300 }}>{name}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="glow-line" />

      {/* How it works */}
      <section id="how-it-works" style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto", scrollMarginTop: 64 }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#1D9E75", marginBottom: 14, fontWeight: 500 }}>How it works</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", maxWidth: 560, lineHeight: 1.12, marginBottom: 52 }}>
            Three ways to study.<br />All built around how SQA marks.
          </div>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }} className="steps-grid">
          {[
            ["01", "Concept chat", "Ask anything on your course. Get clear, SQA-level explanations — exactly what you need, nothing more.", 0],
            ["02", "Past paper feedback", "Paste your answer. Get back exactly what the marker wanted — command words, mark breakdowns, and a model A-grade response.", 100],
            ["03", "Gap drill", "Summit fires SQA-style questions at your weakest topics and scores your answers against real marking logic until you've nailed it.", 200]
          ].map(([num, title, text, delay]) => (
            <Reveal key={num} delay={delay}>
              <div className="step-card">
                <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 40, color: "rgba(29,158,117,0.2)", marginBottom: 18, lineHeight: 1 }}>{num}</div>
                <div style={{ fontSize: 16, fontWeight: 500, color: "#f0f4f2", marginBottom: 10, letterSpacing: -0.2 }}>{title}</div>
                <div style={{ fontSize: 13, color: "rgba(240,244,242,0.38)", lineHeight: 1.75, fontWeight: 300 }}>{text}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="glow-line" />

      {/* Features */}
      <section style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#1D9E75", marginBottom: 14, fontWeight: 500 }}>Features</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", maxWidth: 560, lineHeight: 1.12, marginBottom: 52 }}>
            Built around how<br />SQA actually marks.
          </div>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 20 }} className="features-grid">
          {[
            ["🎯", "Command word engine", "Knows the difference between describe, explain, analyse, and evaluate — and tells you exactly what structure each one needs.", 0],
            ["📋", "Mark allocation awareness", "A 4-mark question needs four distinct points. Summit structures every piece of feedback around the marks available.", 100],
            ["📉", "Weakness tracking", "Remembers where you keep dropping marks and directs your revision at the gaps that will cost you most.", 0],
            ["📅", "Exam countdown planner", "Input your exam dates. Summit builds a daily revision plan that prioritises your most urgent subjects automatically.", 100]
          ].map(([icon, title, text, delay]) => (
            <Reveal key={title} delay={delay}>
              <div className="feature-card">
                <div style={{ width: 44, height: 44, background: "rgba(29,158,117,0.08)", border: "1px solid rgba(29,158,117,0.15)", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18, fontSize: 20 }}>{icon}</div>
                <div style={{ fontSize: 15, fontWeight: 500, color: "#f0f4f2", marginBottom: 9, letterSpacing: -0.2 }}>{title}</div>
                <div style={{ fontSize: 13, color: "rgba(240,244,242,0.38)", lineHeight: 1.75, fontWeight: 300 }}>{text}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="glow-line" />

      {/* AI Study Coach section */}
      <section style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#a78bfa", marginBottom: 14, fontWeight: 500 }}>Elite feature</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", lineHeight: 1.12, marginBottom: 16 }}>
            Your personal<br /><em style={{ fontStyle: "italic", color: "#a78bfa" }}>AI Study Coach.</em>
          </div>
          <p style={{ fontSize: 15, color: "rgba(240,244,242,0.4)", maxWidth: 580, lineHeight: 1.8, fontWeight: 300, marginBottom: 40 }}>
            Not a chatbot. A coach that knows your subjects, tracks every topic you&apos;ve dropped marks on, and tells you exactly what to study today. It adapts to your exam schedule, your confidence levels, and how you like to be coached.
          </p>
        </Reveal>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" }} className="features-grid">
          <Reveal>
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              {[
                ["✦", "Knows you personally", "Remembers your weak topics from every past paper session, your confidence in each subject, your exam dates, and your target grade."],
                ["🎯", "All study modes in one", "Ask it to drill you, generate a full mock paper, mark your answers, or build today\u2019s revision plan \u2014 all without leaving the conversation."],
                ["📅", "Adapts to your timeline", "4 days before your exam it shifts into urgent mode. 3 weeks out it builds a structured sprint. It always knows where you are."],
                ["🎙️", "Coached your way", "Tell it you want to be pushed hard or supported gently. It adjusts its tone to what works for you."],
              ].map(([icon, title, text]) => (
                <div key={title} style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(167,139,250,0.08)", border: "1px solid rgba(167,139,250,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>{icon}</div>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 500, color: "#f0f4f2", marginBottom: 5 }}>{title}</div>
                    <div style={{ fontSize: 13, color: "rgba(240,244,242,0.38)", lineHeight: 1.7, fontWeight: 300 }}>{text}</div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={150}>
            <div style={{ background: "#0a1412", border: "1px solid rgba(167,139,250,0.2)", borderRadius: 16, overflow: "hidden", boxShadow: "0 0 80px rgba(124,58,237,0.1)" }}>
              <div style={{ padding: "14px 20px", borderBottom: "1px solid rgba(167,139,250,0.12)", display: "flex", alignItems: "center", gap: 10, background: "linear-gradient(180deg, rgba(124,58,237,0.08) 0%, transparent 100%)" }}>
                <div style={{ width: 32, height: 32, borderRadius: 9, background: "linear-gradient(135deg, rgba(167,139,250,0.3), rgba(124,58,237,0.2))", border: "1px solid rgba(167,139,250,0.35)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>✦</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#f0f4f2" }}>Summit Coach</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#a78bfa" }} />
                    <div style={{ fontSize: 10, color: "#a78bfa", fontWeight: 300 }}>3 days until first exam</div>
                  </div>
                </div>
              </div>
              <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ padding: "10px 14px", borderRadius: "3px 12px 12px 12px", background: "linear-gradient(135deg, rgba(124,58,237,0.12), rgba(167,139,250,0.06))", border: "1px solid rgba(167,139,250,0.15)", fontSize: 12, color: "#f0f4f2", lineHeight: 1.7, fontWeight: 300 }}>
                  Hey Mia. 3 days out. Your Business Management case study is your biggest gap — you dropped 8 marks on Section 1 in your last mock. Let’s fix that today.
                </div>
                {["Drill me on Section 1 case study questions", "Generate a full Higher BM mock paper", "Build my 3-day revision sprint"].map((opt, i) => (
                  <div key={i} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid rgba(167,139,250,0.2)", background: "rgba(167,139,250,0.05)", color: "#c4b5fd", fontSize: 11, display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ width: 18, height: 18, borderRadius: 4, background: "rgba(167,139,250,0.15)", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 700, color: "#a78bfa", flexShrink: 0 }}>{String.fromCharCode(65+i)}</span>
                    {opt}
                  </div>
                ))}
              </div>
              <div style={{ padding: "10px 20px", borderTop: "1px solid rgba(167,139,250,0.08)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: 10, color: "rgba(240,244,242,0.2)", fontWeight: 300 }}>AI Coach add-on — £7.99 one-off</div>
                <div style={{ fontSize: 10, color: "#a78bfa", fontWeight: 500 }}>✦ Powered by Claude Sonnet</div>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div style={{ marginTop: 48, padding: "20px 28px", background: "rgba(167,139,250,0.05)", border: "1px solid rgba(167,139,250,0.2)", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 20, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 500, color: "#f0f4f2", marginBottom: 4 }}>Add AI Study Coach — £7.99 one-off</div>
              <div style={{ fontSize: 13, color: "rgba(240,244,242,0.35)", fontWeight: 300 }}>Everything in Pro, plus your personal AI coach. Pay once, yours until your last exam.</div>
            </div>
            <button className="btn-primary" onClick={onGetStarted} style={{ background: "linear-gradient(135deg, #a78bfa, #7c3aed)", whiteSpace: "nowrap", flexShrink: 0 }}>Get Pro + Coach →</button>
          </div>
        </Reveal>
      </section>

      <div className="glow-line" />

            {/* ── PREDICTED PAPERS SECTION ── */}
      <section id="predicted-papers" style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto", scrollMarginTop: 64 }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#EF9F27", marginBottom: 14, fontWeight: 500 }}>New feature</div>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 20, flexWrap: "wrap", marginBottom: 16 }}>
            <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", lineHeight: 1.12 }}>
              Predicted Papers.<br /><em style={{ fontStyle: "italic", color: "#EF9F27" }}>Built from SQA patterns.</em>
            </div>
          </div>
          <p style={{ fontSize: 15, color: "rgba(240,244,242,0.4)", maxWidth: 580, lineHeight: 1.8, fontWeight: 300, marginBottom: 14 }}>
            Summit analyses which topics have appeared across SQA papers since 2014 — what's overdue for return, what's appeared every year, what the new course changes signal. The result is a full predicted paper in authentic SQA format, generated once and saved permanently for you.
          </p>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 48 }}>
            <div style={{ fontSize: 13, color: "rgba(240,244,242,0.4)", display: "flex", alignItems: "center", gap: 6, fontWeight: 300 }}>
              <span style={{ color: "#EF9F27" }}>✓</span> Generated once — saved forever, never changes
            </div>
            <div style={{ fontSize: 13, color: "rgba(240,244,242,0.4)", display: "flex", alignItems: "center", gap: 6, fontWeight: 300 }}>
              <span style={{ color: "#EF9F27" }}>✓</span> Full SQA format — questions, marks, command words
            </div>
            <div style={{ fontSize: 13, color: "rgba(240,244,242,0.4)", display: "flex", alignItems: "center", gap: 6, fontWeight: 300 }}>
              <span style={{ color: "#EF9F27" }}>✓</span> Submit answers for instant AI marking
            </div>
          </div>
        </Reveal>

        {/* Paper subject cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 40 }} className="papers-grid">
          {[
            ["📐", "Mathematics", "Paper 1 (Non-calc) + Paper 2 (Calculator)"],
            ["🔬", "Biology", "Multiple Choice + Structured Paper"],
            ["⚗️", "Chemistry", "Multiple Choice + Structured Paper"],
            ["⚡", "Physics", "Multiple Choice + Structured Paper"],
            ["📖", "English", "RUAE + Critical Reading"],
            ["📊", "Business Management", "Full case study paper"],
            ["🌍", "History", "Scottish Paper + World Paper"],
            ["🗺️", "Geography", "Physical & Human + Global Issues"],
          ].map(([icon, subject, papers], i) => (
            <Reveal key={subject} delay={i * 40}>
              <div className="paper-card">
                <div style={{ fontSize: 22, marginBottom: 10 }}>{icon}</div>
                <div style={{ fontSize: 13, fontWeight: 500, color: "#f0f4f2", marginBottom: 5, letterSpacing: -0.2 }}>{subject}</div>
                <div style={{ fontSize: 11, color: "rgba(240,244,242,0.28)", lineHeight: 1.5, fontWeight: 300 }}>{papers}</div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Pricing callout */}
        <Reveal>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "stretch" }}>
            {/* Per-paper */}
            <div style={{ flex: "1 1 220px", padding: "24px", border: "1px solid rgba(239,159,39,0.25)", borderRadius: 14, background: "rgba(239,159,39,0.04)" }}>
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#EF9F27", marginBottom: 12, fontWeight: 500 }}>Pay per subject</div>
              <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 36, color: "#f0f4f2", letterSpacing: -1, marginBottom: 4, lineHeight: 1 }}>
                £4.99<span style={{ fontSize: 13, fontFamily: "'DM Sans', sans-serif", color: "rgba(240,244,242,0.3)", fontWeight: 300 }}> / subject</span>
              </div>
              <div style={{ fontSize: 12, color: "rgba(240,244,242,0.3)", marginBottom: 16, fontWeight: 300, lineHeight: 1.5 }}>
                Unlocks all paper types for that subject — e.g. English unlocks both RUAE and Critical Reading.
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 7, marginBottom: 18 }}>
                {["All paper types for that subject", "Generated once, saved permanently", "Submit for AI marking", "Works on free plan"].map(f => (
                  <div key={f} style={{ fontSize: 12, color: "rgba(240,244,242,0.45)", display: "flex", gap: 8, alignItems: "center", fontWeight: 300 }}>
                    <span style={{ color: "#EF9F27", fontSize: 12 }}>✓</span>{f}
                  </div>
                ))}
              </div>
              <button className="btn-primary" onClick={onGetStarted} style={{ width: "100%", background: "rgba(239,159,39,0.15)", border: "1px solid rgba(239,159,39,0.3)", color: "#EF9F27", padding: "11px" }}
                onMouseOver={e => { e.currentTarget.style.background = "rgba(239,159,39,0.25)"; }}
                onMouseOut={e => { e.currentTarget.style.background = "rgba(239,159,39,0.15)"; }}>
                Get started →
              </button>
            </div>

            {/* Pro included */}
            <div style={{ flex: "1 1 220px", padding: "24px", border: "1px solid rgba(29,158,117,0.35)", borderRadius: 14, background: "rgba(29,158,117,0.05)", position: "relative" }}>
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#1D9E75", marginBottom: 12, fontWeight: 500 }}>Pro — £6.99/mo</div>
              <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 36, color: "#f0f4f2", letterSpacing: -1, marginBottom: 4, lineHeight: 1 }}>
                All subjects<span style={{ fontSize: 13, fontFamily: "'DM Sans', sans-serif", color: "rgba(240,244,242,0.3)", fontWeight: 300 }}> free</span>
              </div>
              <div style={{ fontSize: 12, color: "rgba(240,244,242,0.3)", marginBottom: 16, fontWeight: 300, lineHeight: 1.5 }}>
                Every predicted paper for every subject you study — all included with Pro, nothing extra to pay.
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 7, marginBottom: 18 }}>
                {["All subjects · all levels · all paper types", "Unlimited study messages", "All 4 study modes", "Weakness tracker + planner"].map(f => (
                  <div key={f} style={{ fontSize: 12, color: "rgba(240,244,242,0.55)", display: "flex", gap: 8, alignItems: "center", fontWeight: 300 }}>
                    <span style={{ color: "#1D9E75", fontSize: 12 }}>✓</span>{f}
                  </div>
                ))}
              </div>
              <button className="btn-primary" onClick={onGetStarted} style={{ width: "100%", padding: "11px" }}
                onMouseOver={e => e.currentTarget.style.opacity = "0.88"}
                onMouseOut={e => e.currentTarget.style.opacity = "1"}>
                Get Pro — exam discount →
              </button>
            </div>

            {/* Coach Boost add-on */}
            <div style={{ flex: "1 1 220px", padding: "24px", border: "1px solid rgba(167,139,250,0.35)", borderRadius: 14, background: "rgba(167,139,250,0.05)", position: "relative" }}>
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#a78bfa", marginBottom: 12, fontWeight: 500 }}>AI Coach — £7.99 once</div>
              <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 36, color: "#f0f4f2", letterSpacing: -1, marginBottom: 4, lineHeight: 1 }}>
                Add-on<span style={{ fontSize: 13, fontFamily: "'DM Sans', sans-serif", color: "rgba(240,244,242,0.3)", fontWeight: 300 }}> to Pro</span>
              </div>
              <div style={{ fontSize: 12, color: "rgba(240,244,242,0.3)", marginBottom: 16, fontWeight: 300, lineHeight: 1.5 }}>
                Your personal AI coach unlocked for exam season. Pay once, no subscription.
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 7, marginBottom: 18 }}>
                {["AI coach — knows your weak spots", "Progress dashboard", "Day-by-day revision schedule", "Everything in Pro included"].map(f => (
                  <div key={f} style={{ fontSize: 12, color: "rgba(240,244,242,0.55)", display: "flex", gap: 8, alignItems: "center", fontWeight: 300 }}>
                    <span style={{ color: "#a78bfa", fontSize: 12 }}>✓</span>{f}
                  </div>
                ))}
              </div>
              <button className="btn-primary" onClick={onGetStarted} style={{ width: "100%", padding: "11px", background: "linear-gradient(135deg, #a78bfa, #7c3aed)", border: "none" }}
                onMouseOver={e => e.currentTarget.style.opacity = "0.88"}
                onMouseOut={e => e.currentTarget.style.opacity = "1"}>
                Get Pro + Coach →
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div style={{ marginTop: 20, padding: "12px 16px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, fontSize: 11, color: "rgba(240,244,242,0.25)", fontWeight: 300, lineHeight: 1.6 }}>
            ⚠️ AI-generated based on SQA curriculum patterns. Not an official SQA product. Always supplement with real past papers from sqa.org.uk.
          </div>
        </Reveal>
      </section>

      <div className="glow-line" />

      <div style={{ padding: "60px 48px", maxWidth: 760, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <blockquote style={{ textAlign: "center" }}>
            <div style={{ fontSize: "clamp(18px, 2.5vw, 26px)", fontFamily: "'Instrument Serif', serif", fontStyle: "italic", color: "rgba(240,244,242,0.8)", lineHeight: 1.55, marginBottom: 20, letterSpacing: -0.3 }}>
              &ldquo;My teacher never had time to mark every answer. Summit does it in seconds and tells me exactly what the marker wanted. I went up two grades.&rdquo;
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(29,158,117,0.15)", border: "1px solid rgba(29,158,117,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#4DC9A0" }}>J</div>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: 13, color: "rgba(240,244,242,0.6)", fontWeight: 500 }}>Jamie, Higher Business Management</div>
                <div style={{ display: "flex", gap: 1, marginTop: 2 }}>{[...Array(5)].map((_,i) => <span key={i} style={{ color: "#1D9E75", fontSize: 11 }}>★</span>)}</div>
              </div>
            </div>
          </blockquote>
        </Reveal>
      </div>

      <div className="glow-line" />

      {/* Social proof strip before pricing */}
      <div style={{ background: "rgba(29,158,117,0.05)", borderTop: "1px solid rgba(29,158,117,0.1)", borderBottom: "1px solid rgba(29,158,117,0.1)", padding: "18px 48px", textAlign: "center" }}>
        <div style={{ fontSize: 13, color: "rgba(240,244,242,0.4)", fontWeight: 300 }}>
          Trusted by <span style={{ color: "#4DC9A0", fontWeight: 600 }}>5,000+ Scottish students</span> · Used before prelims, assignments and final exams · Rated 5★ by students across Scotland
        </div>
      </div>

      {/* Comparison table */}
      <section style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", textAlign: "center", marginBottom: 48, lineHeight: 1.12 }}>
            How Summit compares
          </div>
        </Reveal>
        <Reveal>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
              <thead>
                <tr>
                  {[["", null], ["Summit Pro", "#1D9E75"], ["Textbook", null], ["Private Tutor", null], ["Past Paper Site", null]].map(([label, color]) => (
                    <th key={label} style={{ padding: "12px 16px", textAlign: label ? "center" : "left", fontWeight: 600, fontSize: 13, color: color || "rgba(240,244,242,0.35)", borderBottom: color ? "2px solid #1D9E75" : "1px solid rgba(255,255,255,0.07)", background: color ? "rgba(29,158,117,0.05)" : "transparent" }}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ["Monthly cost", "£6.99/mo", "One-off cost", "£30-60/hr", "Free-£10"],
                  ["SQA marking feedback", "✓", "✗", "Sometimes", "✗"],
                  ["Available at midnight", "✓", "✓", "✗", "✓"],
                  ["Tracks your weak spots", "✓", "✗", "Maybe", "✗"],
                  ["Personalised to you", "✓", "✗", "✓", "✗"],
                  ["Mock papers + AI marking", "✓", "✗", "Sometimes", "✗"],
                ].map(([feature, ...vals]) => (
                  <tr key={feature} style={{ borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
                    <td style={{ padding: "14px 16px", color: "rgba(240,244,242,0.5)", fontSize: 13, fontWeight: 300 }}>{feature}</td>
                    {vals.map((v, i) => (
                      <td key={i} style={{ padding: "14px 16px", textAlign: "center", background: i === 0 ? "rgba(29,158,117,0.04)" : "transparent", color: v === "✓" ? "#1D9E75" : v === "✗" ? "rgba(240,244,242,0.15)" : "rgba(240,244,242,0.45)", fontSize: v === "✓" || v === "✗" ? 16 : 13, fontWeight: i === 0 ? 600 : 300 }}>{v}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
      </section>

      <div className="glow-line" />

      {/* Pricing */}
      <section id="pricing" style={{ padding: "80px 48px", maxWidth: 1100, margin: "0 auto", scrollMarginTop: 64 }} className="section-pad">
        <Reveal>
          <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: "uppercase", color: "#1D9E75", marginBottom: 14, fontWeight: 500 }}>Pricing</div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 44px)", letterSpacing: -1, color: "#f0f4f2", marginBottom: 12, lineHeight: 1.12 }}>
            Simple pricing.<br />Cancel any time.
          </div>
          <div style={{ fontSize: 14, color: "rgba(240,244,242,0.35)", marginBottom: 48, fontWeight: 300 }}>
            Pro costs less than a single tutoring hour and is available 24/7 until your last exam. Add the AI Coach for a one-off £7.99.
          </div>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 20, maxWidth: 720 }} className="pricing-grid">
          {/* Free */}
          <Reveal delay={0}>
            <div className="plan-card">
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "rgba(240,244,242,0.28)", marginBottom: 14, fontWeight: 500 }}>Free</div>
              <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 44, color: "#f0f4f2", letterSpacing: -1.5, marginBottom: 4, lineHeight: 1 }}>£0</div>
              <div style={{ fontSize: 12, color: "rgba(240,244,242,0.28)", marginBottom: 24, fontWeight: 300 }}>No card required</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
                {["10 messages per day", "Concept chat only", "1 subject", "Predicted papers: £4.99 per subject"].map(f => (
                  <div key={f} style={{ fontSize: 13, color: f.includes("£4.99") ? "rgba(239,159,39,0.7)" : "rgba(240,244,242,0.38)", display: "flex", gap: 10, fontWeight: 300, alignItems: "center" }}>
                    <span style={{ color: f.includes("£4.99") ? "#EF9F27" : "#1D9E75", fontSize: 14 }}>✓</span>{f}
                  </div>
                ))}
              </div>
              <button onClick={onGetStarted} style={{ width: "100%", padding: "13px", background: "transparent", color: "#f0f4f2", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8, fontSize: 14, fontFamily: "'DM Sans', sans-serif", cursor: "pointer" }}>
                Start free
              </button>
            </div>
          </Reveal>

          {/* Pro */}
          <Reveal delay={100}>
            <div className="plan-card featured" style={{ position: "relative" }}>
              <div style={{ position: "absolute", top: -13, left: "50%", transform: "translateX(-50%)", background: "#1D9E75", color: "white", fontSize: 11, padding: "3px 14px", borderRadius: 20, fontWeight: 600, letterSpacing: 0.5, whiteSpace: "nowrap" }}>
                ⭐ MOST POPULAR
              </div>
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#1D9E75", marginBottom: 14, fontWeight: 500 }}>Pro</div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 44, color: "#f0f4f2", letterSpacing: -1.5, lineHeight: 1 }}>
                  £6.99<span style={{ fontSize: 16, fontFamily: "'DM Sans', sans-serif", color: "rgba(240,244,242,0.3)", fontWeight: 300 }}>/mo</span>
                </div>
                <span className="discount-badge">40% OFF</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
                <span className="original-price" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}>was £11.65/mo</span>
                <span style={{ fontSize: 12, color: "rgba(240,244,242,0.28)", fontWeight: 300 }}>· or £23.99/year</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
                {[
                  ["Unlimited messages", false],
                  ["All 4 study modes", false],
                  ["All 24+ SQA subjects", false],
                  ["Weakness tracker + planner", false],
                  ["All predicted papers — free", true]
                ].map(([f, highlight]) => (
                  <div key={f} style={{ fontSize: 13, color: highlight ? "#EF9F27" : "rgba(240,244,242,0.7)", display: "flex", gap: 10, fontWeight: highlight ? 500 : 300, alignItems: "center" }}>
                    <span style={{ color: highlight ? "#EF9F27" : "#1D9E75", fontSize: 14, flexShrink: 0 }}>✓</span>{f}
                  </div>
                ))}
              </div>
              <button onClick={onGetStarted} style={{ width: "100%", padding: "13px", background: "#1D9E75", color: "white", border: "none", borderRadius: 8, fontSize: 14, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, cursor: "pointer", transition: "all 0.2s" }}
                onMouseOver={e => e.currentTarget.style.opacity = "0.88"}
                onMouseOut={e => e.currentTarget.style.opacity = "1"}>
                Claim exam discount →
              </button>
              <div style={{ fontSize: 11, color: "rgba(240,244,242,0.25)", textAlign: "center", marginTop: 12, fontWeight: 300 }}>
                Cancel any time · Only {spotsLeft} discounted places left
              </div>
            </div>
          </Reveal>
        </div>

        {/* Coach Boost add-on */}
        <Reveal delay={150}>
          <div style={{ marginTop: 20, maxWidth: 720, padding: "28px 32px", background: "rgba(124,58,237,0.05)", border: "1px solid rgba(167,139,250,0.3)", borderRadius: 16, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ width: 44, height: 44, borderRadius: 12, background: "linear-gradient(135deg, rgba(167,139,250,0.2), rgba(124,58,237,0.1))", border: "1px solid rgba(167,139,250,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>✦</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#f0f4f2", marginBottom: 3 }}>Add AI Study Coach — <span style={{ color: "#a78bfa" }}>£7.99 one-off</span></div>
                <div style={{ fontSize: 12, color: "rgba(240,244,242,0.35)", fontWeight: 300 }}>Your personal tutor that knows your weak spots and tells you exactly what to study. Pay once, yours until your last exam.</div>
              </div>
            </div>
            <button onClick={onGetStarted} style={{ padding: "11px 24px", background: "linear-gradient(135deg, #a78bfa, #7c3aed)", color: "white", border: "none", borderRadius: 8, fontSize: 13, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }}>
              Get Pro + Coach →
            </button>
          </div>
        </Reveal>
      </section>

      <section style={{ padding: "80px 48px", maxWidth: 760, margin: "0 auto" }} className="section-pad">
        <Reveal>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(26px, 3.5vw, 40px)", letterSpacing: -1, color: "#f0f4f2", textAlign: "center", marginBottom: 48, lineHeight: 1.12 }}>
            Common questions
          </div>
        </Reveal>
        {[
          ["Will this actually help 2 weeks before exams?", "Yes — this is when Summit is most useful. You need to know exactly which topics to focus on, get instant feedback on your answers, and practise under exam conditions. Students who use Summit in the final 2 weeks consistently report feeling more prepared because they’re targeting gaps, not just revising everything."],
          ["How is this different from ChatGPT?", "ChatGPT doesn’t know SQA marking schemes, command words, or how Scottish exams are structured. Summit is built specifically for SQA — it knows what ‘explain’ vs ‘describe’ means in a marking context, tracks your weak topics, and gives feedback in the format SQA markers actually use."],
          ["Is it worth it if I only have a few subjects?", "Even for one subject, the past paper feedback alone is worth it. Most students can’t get detailed marking feedback on every practice answer from their teacher. Summit gives you that on demand, as many times as you need."],
          ["What if I’m not happy with it?", "Cancel any time — no questions, no forms, no waiting. Just cancel before your next billing date and you won’t be charged again."],
          ["Does it work for National 5 as well as Higher?", "Yes — Summit covers National 5, Higher, and Advanced Higher across all 24+ SQA subjects. You set your level during onboarding and everything is tailored to it."],
        ].map(([q, a], i) => (
          <Reveal key={q} delay={i * 60}>
            <details style={{ borderBottom: "1px solid rgba(255,255,255,0.06)", padding: "20px 0" }}>
              <summary style={{ fontSize: 15, fontWeight: 500, color: "#f0f4f2", cursor: "pointer", listStyle: "none", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
                {q}
                <span style={{ color: "#1D9E75", fontSize: 20, flexShrink: 0, fontWeight: 300 }}>+</span>
              </summary>
              <div style={{ fontSize: 14, color: "rgba(240,244,242,0.45)", lineHeight: 1.8, fontWeight: 300, marginTop: 14 }}>{a}</div>
            </details>
          </Reveal>
        ))}
      </section>

      <div className="glow-line" />

      {/* Final CTA */}
      <div className="glow-line" />
      <section className="cta-section" style={{ padding: "100px 48px", textAlign: "center" }}>
        <Reveal>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: "clamp(28px, 4.5vw, 56px)", letterSpacing: -1.5, color: "#f0f4f2", marginBottom: 16, lineHeight: 1.1 }}>
            {started
              ? <>Exams are here.<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>Make every mark count.</em></>
              : days === 0
                ? <>First exam tomorrow.<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>Make it count.</em></>
                : <>{days} days.<br /><em className="gradient-text" style={{ fontStyle: "italic" }}>Make them count.</em></>
            }
          </div>
          <p style={{ fontSize: 16, color: "rgba(240,244,242,0.4)", fontWeight: 300, maxWidth: 420, margin: "0 auto 12px", lineHeight: 1.7 }}>
            Every hour you study smarter is worth three hours of unfocused revision. Summit makes every session count.
          </p>
          <p style={{ fontSize: 13, color: "rgba(240,244,242,0.22)", marginBottom: 36, fontWeight: 300 }}>Free to start. Takes 2 minutes. No card required.</p>
          <button className="btn-primary" onClick={onGetStarted} style={{ fontSize: 16, padding: "15px 40px" }}>
            Start studying free →
          </button>
        </Reveal>
      </section>

      {/* Footer */}
      <footer style={{ padding: "28px 48px", borderTop: "1px solid rgba(255,255,255,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }} className="footer-pad">
        <img src={SummitPrimary} alt="Summit" style={{ height: 220, width: "auto", display: "block" }} />
        <a href="/legal.html" style={{ color: "rgba(240,244,242,0.3)", fontSize: 12, textDecoration: "none" }}>Terms & Privacy</a>
        <div style={{ fontSize: 12, color: "rgba(240,244,242,0.18)", fontWeight: 300 }}>© 2026 Summit. Built for Scottish students.</div>
      </footer>
      <SocialProofToast />
    </div>
  );
}